var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.asegurado_svg)?_c('img',{staticClass:"siniestro-svg-img",attrs:{"src":_vm.asegurado_svg}}):_vm._e(),_vm._v(" "+_vm._s(_vm.siniestro_prop.asegurado)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }